/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Learn_More_PlusInputs */

const en_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more about Plus`)
};

const ar_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على المزيد حول بلس`)
};

const de_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahren Sie mehr über Plus`)
};

const es_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más información sobre Plus`)
};

const fr_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur Plus`)
};

const it_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ScoprI di più su Plus`)
};

const ja_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusの詳細を見る`)
};

const ko_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 자세히 알아보기`)
};

const pt_br_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais sobre o Plus`)
};

const ru_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Узнать больше о Plus`)
};

const th_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้เพิ่มเติมเกี่ยวกับ Plus`)
};

const tr_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus hakkında daha fazla bilgi edin`)
};

const zh_cn_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多 Plus`)
};

const zh_tw_daily_paywall_learn_more_plus = /** @type {(inputs: Daily_Paywall_Learn_More_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解更多 Plus`)
};

/**
* | output |
* | --- |
* | "Learn more about Plus" |
*
* @param {Daily_Paywall_Learn_More_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_learn_more_plus = /** @type {((inputs?: Daily_Paywall_Learn_More_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Learn_More_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_learn_more_plus(inputs)
	if (locale === "ar") return ar_daily_paywall_learn_more_plus(inputs)
	if (locale === "de") return de_daily_paywall_learn_more_plus(inputs)
	if (locale === "es") return es_daily_paywall_learn_more_plus(inputs)
	if (locale === "fr") return fr_daily_paywall_learn_more_plus(inputs)
	if (locale === "it") return it_daily_paywall_learn_more_plus(inputs)
	if (locale === "ja") return ja_daily_paywall_learn_more_plus(inputs)
	if (locale === "ko") return ko_daily_paywall_learn_more_plus(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_learn_more_plus(inputs)
	if (locale === "ru") return ru_daily_paywall_learn_more_plus(inputs)
	if (locale === "th") return th_daily_paywall_learn_more_plus(inputs)
	if (locale === "tr") return tr_daily_paywall_learn_more_plus(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_learn_more_plus(inputs)
	return zh_tw_daily_paywall_learn_more_plus(inputs)
});